import ptBr from "../lang/pt/index";
import en from "../lang/en/index";
import es from "../lang/es/index";

const languages = {
    ptBr: ptBr,
    en: en,
    es: es,
};

export const translate = function (term, lang, replaces, defaultMessage = null) {
    lang = languages[lang];
    if (!term) {
        return "";
    }
    let args = term.split("-");
    for (let i = 0; i < args.length; i++) {
        if (!lang[args[i]]) {
            return defaultMessage || term;
        }
        lang = lang[args[i]];
    }
    let text = lang;
    if (replaces) {
        for (let r in replaces) {
            text = text.replace("{$" + r + "}", replaces[r]);
            text = text.replace("{" + r + "}", replaces[r]);
        }
    }
    return text;
};

export const t = function (term, lang, replaces, defaultMessage = null) {
    return translate(term, lang, replaces, defaultMessage);
};

export const getTranslator = (lang) => (term, replaces, defaultMessage = null) =>
    translate(term, lang, replaces, defaultMessage);

const vlang = function (el, binding, vnode) {
    let lang = vnode.context.$root.lang;
    let term = binding.value;
    let replaces = binding.value;
    let text = t(term, lang, replaces);
    el.innerHTML = text;
};

export default languages;

export const directive = {
    bind: (el, binding, vnode) => {
        vlang(el, binding, vnode);
    },
    update: (el, binding, vnode) => {
        vlang(el, binding, vnode);
    },
};
